import React, { useEffect, useRef, useState } from 'react'
import NavigationProgressBarBody from './body/NavigationProgressBarBody'
import { NavigationProgressBarProps } from '../../../../@types/props-types'

import './NavigationProgressBar.css'
import { useShowDebounce } from '../../../common/display/tooltipContent/levitatingTooltip/useShowDebounce'

const NavigationProgressBar: React.FunctionComponent<NavigationProgressBarProps> = ({
  flowInformation,
  screens,
  screenNo,
  onNavigate,
  validationMessages,
}: NavigationProgressBarProps) => {
  useShowDebounce()
  const ref = useRef<HTMLHeadingElement>(null)
  const [isScrolling, setIsScrolling] = useState(false)
  const [moveNavSideBar, setMoveNavSideBar] = useState(0.0)

  const handleScroll = () => {
    const footer = document.querySelector('#is24-footer')?.getBoundingClientRect()

    const clientHeight = window.innerHeight || document.documentElement.clientHeight
    const hasSmallHeight = clientHeight < 575
    const move = clientHeight - (footer?.top ?? 0)
    if (move > 1) {
      hasSmallHeight && setMoveNavSideBar(Math.round(move - (clientHeight - 575)))
      !hasSmallHeight && setMoveNavSideBar(Math.round(move))
    } else {
      setMoveNavSideBar(0)
    }
    return window.scrollY > 200 ? setIsScrolling(true) : setIsScrolling(false)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div ref={ref} className='sticky-side-nav grid-item one-fourth palm-one-whole lap-one-whole'>
      <div
        className={`palm-hide lap-hide ${isScrolling ? 'scrolled margin-top-xl' : ''}`}
        style={{ width: ref.current ? ref.current.clientWidth : 150, top: moveNavSideBar * -1 }}
      >
        <NavigationProgressBarBody
          flowInformation={flowInformation}
          screenNo={screenNo}
          screens={screens}
          onNavigate={onNavigate}
          validationMessages={validationMessages}
        />
      </div>
    </div>
  )
}

export default NavigationProgressBar
